import React from 'react'
import NewsDiv from './NewsDiv/NewsDiv'
import "./newsdivs.css"

function NewsDivs(props) {
  return (<> <NewsDiv title={props.title} time ={props.time} author={props.author }/>
      
      {/* <NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /><NewsDiv bgc="bgc" title={props.title} /><NewsDiv title={props.title} /> */}</>
   
      
    
  )
}

export default NewsDivs